import { Component, OnInit } from '@angular/core';
import { MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { HomeService } from 'src/home/home.service';
import { PaginatorService } from 'src/home/paginator.service';
import { Contact, ContactListResponse } from 'src/models/Contacts.interface';
import Swal from 'sweetalert2';
import { CreateContactComponent } from '../crm-create-contact/create-contact.component';
import { MatDialog } from '@angular/material/dialog';
import { CrmService } from 'src/home/crm/services/crm.service';

@Component({
  selector: 'app-contacts-list',
  templateUrl: './contacts-list.component.html',
  styleUrls: ['./contacts-list.component.css'],
  providers: [{ provide: MatPaginatorIntl, useClass: PaginatorService }]
})
export class ContactListComponent implements OnInit {

  contacts: Contact[] = [];
  allContacts: Contact[] = [];
  totalContacts: number = 0;
  pageSize: number = 10; // Tamaño de página
  pageIndex: number = 0; // Índice de página

  public isLoading: boolean = false;

  constructor(private homeService: HomeService, public dialog: MatDialog, private crmService: CrmService) { }

  ngOnInit(): void {
    this.handleLoadContacts();
  }

  handleLoadContacts(pageIndex: number = 0, pageSize: number = 10): void {
    this.isLoading = true;
    this.crmService.getContacts(1, 1000).subscribe(
      (data: ContactListResponse) => {
        this.isLoading = false;
        this.allContacts = data.results;
        this.totalContacts = this.allContacts.length;
        this.updateContacts();
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          text: 'Hubo un error al cargar los contactos',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33'
        });
      }
    );
  }


  updateContacts(): void {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.contacts = this.allContacts.slice(startIndex, endIndex);
  }

  handlePageEvent($event: PageEvent): void {
    this.pageIndex = $event.pageIndex;
    this.pageSize = $event.pageSize;
    this.updateContacts();
  }

  openCreateContactModal(): void {
    const dialogRef = this.dialog.open(CreateContactComponent, {
      width: '70%',
      maxWidth: '600px',
      data: { title: 'Agregar Contacto' },
    });

    dialogRef.afterClosed().subscribe(newContact => {
      if (newContact) {
        this.isLoading = false;
        Swal.fire({
          text: 'Contacto creado exitosamente',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#4caf50',
        });
        this.handleLoadContacts(this.pageIndex, this.pageSize);
      } else {
        this.isLoading = false;
        Swal.fire({
          text: 'Hubo un error al crear el contacto',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        })
      }
    });
  }

}
